const CHUNK_LOAD_ERROR_PATTERNS = [
  'ChunkLoadError',
  'Loading chunk',
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
];

const RELOAD_STORAGE_PREFIX = 'tb360-chunk-load-reload:';
const activeRecoveries = new Set<string>();
let recoveryBlocked = false;
const recoveryListeners = new Set<() => void>();

function notifyRecoveryListeners(): void {
  recoveryListeners.forEach(listener => listener());
}

export function isChunkRecoveryBlocked(): boolean {
  return recoveryBlocked;
}

export function subscribeToChunkRecovery(listener: () => void): () => void {
  recoveryListeners.add(listener);
  return () => recoveryListeners.delete(listener);
}

export function blockChunkLoadRecovery(): void {
  if (recoveryBlocked) return;
  recoveryBlocked = true;
  notifyRecoveryListeners();
}

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return CHUNK_LOAD_ERROR_PATTERNS.some(pattern => message.includes(pattern));
}

export function startChunkLoadRecovery(release: string): boolean {
  if (activeRecoveries.has(release)) return true;

  const storageKey = `${RELOAD_STORAGE_PREFIX}${release}`;
  try {
    if (sessionStorage.getItem(storageKey)) {
      return false;
    }
    sessionStorage.setItem(storageKey, 'true');
  } catch {
    // Without session storage a reload loop cannot be guarded safely.
    return false;
  }

  activeRecoveries.add(release);
  window.location.reload();
  return true;
}

export function installChunkLoadRecovery(release: string): () => void {
  const handleUnhandledRejection = (event: PromiseRejectionEvent): void => {
    if (!isChunkLoadError(event.reason)) return;

    event.preventDefault();
    if (!startChunkLoadRecovery(release)) blockChunkLoadRecovery();
  };

  window.addEventListener('unhandledrejection', handleUnhandledRejection);
  return () => window.removeEventListener('unhandledrejection', handleUnhandledRejection);
}
